import Constant from '@/const';
import axios from 'axios';

const putStatusDrugs = async payload => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/drugs/activation`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putStatusDrugs;
